module.exports = __webpack_public_path__ + "static/media/somaiya.jpg.bb48f467.webp";